export enum ELEMENT_TYPE {
    TEXT = 'text',
    IMAGE = 'image',
    LOGO = 'logo',
    QUIZ = 'quiz',
    EMAIL_FIELD = 'email_field',
    PHONE_FIELD = 'phone_field',
    BUTTON = 'button',
    TERMS = 'terms',
    SPINNER = 'spinner',
    COUPON_CODE = 'coupon_code'
}

export enum TEMPLATE_CANVAS_TYPE {
    SINGLE_IMAGE = 'single_image',
    MULTI_IMAGE = 'multi_image'
}
